export default __webpack_public_path__ + "static/media/notal-premium-bg.b8977ff1.png";